<p-dialog header="{{ approvalAddEditHeader }}" [(visible)]="displayAddApproval" (onHide)="dialogClose()" [modal]="true" [responsive]="true" [style]="{ width: '50vw' }">
    <div class="card">
        <form [formGroup]="approvalDetailsForm" novalidate>
            <div class="p-field p-formgrid p-grid">
                <!-- <div class="p-col-12">
                    <div class="p-d-flex align-items-center p-mb-3">
                        <p-checkbox name="isApprovalSequenceEnabled" value="true" [binary]="true"  formControlName="isApprovalSequenceEnabled" [disabled]="viewOnly" inputId="isApprovalSequenceEnabled"></p-checkbox>
                        <label for="isApprovalSequenceEnabled" class="p-ml-2">Approval Sequence</label>
                    </div>
                </div> -->
                <div class="p-col-12" formArrayName="approvals">
                    <p-table [value]="getApprovals(approvalDetailsForm)" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="value.productId">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngIf="approvalDetailsForm.getRawValue().isApprovalSequenceEnabled" style="width: 5rem"></th>
                                <th style="width: 150px">Assign Type</th>
                                <th>Select User</th>
                                <th style="width: 4rem" class="p-py-0" *ngIf="!viewOnly">
                                    <span class="btnBars" (click)="addApproval()">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-approvalControl let-index="rowIndex">
                            <tr [formGroupName]="index">
                                <td *ngIf="approvalDetailsForm.getRawValue().isApprovalSequenceEnabled" style="width: 5rem">
                                    <strong>{{ index+1 }}</strong>
                                </td>
                                <td style="width: 150px" pEditableColumn class="action">
                                    <p-dropdown
                                        [options]="assignedTypes"
                                        formControlName="assignedType"
                                        optionLabel="name"
                                        optionValue="id" appendTo="body"
                                        [dropdownIcon]="dropdownIcon"
                                        [readOnly]="viewOnly">
                                    </p-dropdown>
                                </td>
                                <td pEditableColumn class="action">
                                    <!-- <p-dropdown
                                        [options]="activeUsers"
                                        formControlName="assignedId"
                                        optionLabel="name"
                                        optionValue="id" appendTo="body"
                                        [filter]="true"
                                        placeholder="Select User"
                                        class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                        [readonly]="viewOnly">
                                    </p-dropdown> -->
                                    <liono-treeSelect
                                        formControlName="assignedId"
                                        [options]="activeUserTree"
                                        [selectionMode]="'single'"
                                        [metaKeySelection]="false"
                                        [filter]="true"
                                        [filterBy]="'name'"
                                        filterPlaceholder="Search User..."
                                        class="noBorderDD"
                                        appendTo="body" placeholder="Select User">
                                    </liono-treeSelect>
                                </td>
                                <td *ngIf="!viewOnly">
                                    <div class="p-d-flex">
                                        <span class="btnBars p-mr-0"
                                            (click)="removeApproval(index)">
                                            <i class="pi pi-trash"></i>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="button" pButton (click)="dialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveApproval()" label="Save"></button>
    </p-footer>
</p-dialog>
